import React, {useContext} from "react";
import {Alert, Button} from "react-bootstrap";
import {ReactReduxContext} from "react-redux";
import {SESSION_EXPIRED} from "../../../../_utils/constants/Auth";

// True when the JWT in "Bearer <token>" is past its expiry. A token that isn't a JWT is never called expired.
const tokenExpired = (authorization) => {
  try {
    const payload = String(authorization || "").replace(/^Bearer\s+/i, "").split(".")[1];
    if (!payload) return false;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const {exp} = JSON.parse(atob(base64 + "===".slice((base64.length + 3) % 4)));
    return Number.isFinite(exp) && exp * 1000 <= Date.now();
  } catch (_) {return false;}
};

// The one rule every RSO read uses. NANCY answers 401 only for a missing, invalid or expired sign-in:
// RSO permission problems are 403 and forecasting-service failures 503. If the browser gets no answer at all
// (for example a proxy hid the 401), the request's own token being past its expiry still means sign in again.
// failure.request is set only for a request that was sent, so checks in the code and cancelled reads never count.
export const isSignInExpired = (failure) => failure?.response?.status === 401
  || (!failure?.response && !!failure?.request && tokenExpired(failure?.config?.headers?.Authorization));

// "Sign in again." runs NANCY's own expired-session path: the stored sign-in is cleared and NANCY opens its
// login page. (A plain link to /login would bounce straight back while the expired sign-in is still stored.)
// Without a redux store (RSO unit tests) the message is plain text.
export default function RsoSignInExpired({className = "", role = "alert"}) {
  const redux = useContext(ReactReduxContext);
  return <Alert variant="warning" role={role} className={className}>Your sign-in has expired.{" "}
    {redux?.store ? <Button variant="link" className="p-0 align-baseline"
      onClick={() => redux.store.dispatch({type: SESSION_EXPIRED})}>Sign in again.</Button> : "Sign in again."}
  </Alert>;
}
